import React, { Component } from 'react';
import { Link, utils } from '@ltfe/ltfe-core-lib';

import {
    View,
    StyleSheet
} from 'react-native';

import {
    JDText,
    JDPopupWindow,
    JDImage,
    JDTouchable
} from '@jdreact/jdreact-core-lib';

const { pt } = utils;

class VerifyInfo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            num: 1,
            theCityCode: '',
            skuAttrDetail: this.props.skuAttrDetail,
            promoPriceType: 2, // 促销类型
            GoodsPromotionVO: this.props.GoodsPromotionVO,
            isShow: false,
            cityCode: null,
            skuId: this.props.skuId
        };
    }

    render() {
        const { show, verifyMsg } = this.props;

        return (
            verifyMsg.name
                ? <JDPopupWindow show={ show } height={ pt(407) } onHide={ this.hide } >
                    <View style={ st.package_wrap }>
                        <JDTouchable style={ st.close_touch } onPress={ this.hide }>
                            <JDImage style={ st.close_img } source={ { uri: 'https://m.360buyimg.com/mobilecal/jfs/t1/105456/12/2632/766/5dd4eb75Ecd5d30d5/b18979d1825ea64f.png' } } />
                        </JDTouchable>
                        <View style={ { flex: 1, marginLeft: pt(18), marginTop: pt(48) } }>
                            <JDText style={ st.tittle }>购票贴士</JDText>
                            <JDText style={ st.txt_gray }>京东认证实名信息将用于用户购买电影票</JDText>
                            <JDText style={ st.txt_info }>姓名：{verifyMsg.name}</JDText>
                            <JDText style={ st.txt_info }>证件号：{verifyMsg.idNo}</JDText>
                        </View>
                        <View style={ st.bottom }>
                            <View style={ st.btn_wrap }>
                                <Link onPress={ () => {
                                    this.hide();
                                } }>
                                    {/* <LinearGradient style={st.btn_wrap} colors={['#F10000', '#FF2000', '#FF4F18']} start={{ x: 0, y: 0 }} end={{ x: 1, y: 0 }}>
                                    <JDText style={st.btn_txt}>确定</JDText>
                                </LinearGradient> */}
                                    <View style={ [st.btn_wrap, st.webStyle] }>
                                        <JDText style={ st.btn_txt }>确定</JDText>
                                    </View>
                                </Link>
                            </View>
                        </View>

                    </View>
                </JDPopupWindow>
                : null
        );
    }

    hide = () => {
        this.props && this.props.onHide();
    }
}

const st = StyleSheet.create({
    package_wrap: {
        backgroundColor: '#fff',
        width: pt(375),
        borderTopLeftRadius: pt(12),
        borderTopRightRadius: pt(12),
        height: pt(243)
    },
    tittle: {
        fontSize: pt(18),
        fontWeight: 'bold',
        marginBottom: pt(18)
    },
    txt_gray: {
        color: '#525252',
        fontSize: pt(13),
        marginBottom: pt(12)
    },
    txt_info: {
        fontSize: pt(13),
        color: '#262626',
        marginBottom: pt(12),
        fontFamily: 'PingFangSC-Medium'
    },
    close_img: {
        height: pt(20),
        width: pt(20)
    },
    close_touch: {
        position: 'absolute',
        top: pt(24),
        right: pt(18)
    },

    bottom: {
        backgroundColor: '#fff',
        height: global.isIPhoneX ? pt(85) : pt(51),
        justifyContent: 'space-between',
        flexDirection: 'row',
        width: pt(375),
        alignItems: 'center',
        paddingBottom: global.isIPhoneX ? pt(34) : pt(0),
        paddingHorizontal: pt(18),
        borderTopColor: '#F2F2F2',
        borderTopWidth: pt(1),
        marginTop: pt(-1)
    },
    btn_wrap: {
        // flex: 1,
        borderRadius: pt(38),
        width: pt(339),
        height: pt(38),
        justifyContent: 'center',
        alignItems: 'center'
    },
    btn_txt: {
        color: '#fff',
        fontSize: pt(18)
    },
    webStyle: {
        background: 'linear-gradient(135deg, rgb(242, 20, 12) 20%, rgb(242, 39, 12) 70%, rgb(242, 77, 12) 100%)'
    }
});

export default VerifyInfo;
// export default connect(mapStateToProps, mapDispatchToProps, null, {withRef: true })(ShopComboModal);
